import BadgeStyle from "../templates/Badge.style";
var badgeData = {
  name: 'badge',
  data: [{}],
  onlyTemplate: {
    base: BadgeStyle
  }
};
export default badgeData;